// Prefer keyboard overlaying content so bottom nav stays at bottom (covered by keyboard when input focused)
if ('virtualKeyboard' in navigator) {
  (navigator as any).virtualKeyboard.overlaysContent = true;
}

// Must stay first: initialises Sentry before React renders. Do not let
// "Organize Imports" move it.
import { environment, posthogEnabled } from './instrument';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { PostHogProvider } from 'posthog-js/react';
import App from './App';
import './index.css';
import config from '../auth_config.json';

const authContent = (
  <Auth0Provider
    domain={config.domain}
    clientId={config.clientId}
    useRefreshTokens={true}
    cacheLocation="localstorage"
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: config.audience,
      scope:
        'openid profile email offline_access read:profile update:profile read:calls update:calls',
    }}
  >
    <App />
  </Auth0Provider>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {posthogEnabled ? (
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY!}
        options={{
          api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
          defaults: '2025-05-24',
          capture_exceptions: true,
          debug: false,
          // Stamps every event so PostHog can be filtered by environment the
          // same way Sentry's native `environment` dimension is.
          loaded: (posthog) => posthog.register({ environment }),
        }}
      >
        {authContent}
      </PostHogProvider>
    ) : (
      authContent
    )}
  </React.StrictMode>
);
